const CLIPBOARD_MESSAGE_ERROR = 'Error writing to clipboard';
const writeToClipBoard = async text => {
  try {
    await navigator.clipboard.writeText(text);
    return text;
  } catch (_unused) {
    try {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      document.body.appendChild(input);
      input.value = text;
      input.focus();
      input.select();
      document.execCommand('copy');
      input.remove();
      return text;
    } catch (_unused2) {
      throw new Error(CLIPBOARD_MESSAGE_ERROR);
    }
  }
};
export { writeToClipBoard as default };
